import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useReducer,useEffect } from "react";
import { getSliders } from "../Service/Api";


const dummyData ={
 sliders: [
    {
      id: "fallback-slider",
      attachment:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/sld1.jpg",
      visibility: false,
    },
  ],
  isLoading: true,
  isError: false,
}


function reducerFn(state, action) {
  switch (action.type) {
    case "slider_fetch":
      return {
        ...state,
        sliders: action.payload,
        isLoading: false,
        isError: false,
      };

    case "slider_error":
      return {
        ...state,
        isLoading: false,
        isError: true,
        // Existing fallback slider remains in state.
      };

    default:
      return state;
  }
}
const Events = () => {
  var settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };


  const[iniitalData, dispatch] = useReducer(reducerFn,dummyData)

  useEffect(function(){
    async function getSliderData(){
     try {
      let slider_Data_await = await getSliders()
      let slider_Data_await_filter = slider_Data_await.filter(function(item,index,arr){
        return item.visibility === false
      })
      dispatch({
        type:'slider_fetch',
        payload: slider_Data_await_filter,
       

      })
      
     } catch (error) {
       dispatch({
         type: 'slider_error',
        isError:false})
      console.error('this is error message',error.message)
      
     }


    }
    getSliderData()
  },[])


  console.log('this is slider data',iniitalData)


  if(iniitalData.isLoading){
    return (
      <Slider {...settings}>
        {iniitalData.sliders.map(function(slider, index) {
          return (
            <div className="item" key={slider.id || index}>
              <img
                src={slider.attachment}
                alt="Loading slider"
              />
            </div>
          )
        })}
      </Slider>
    )
  }


  return (
    <Slider {...settings}>
      {[...iniitalData.sliders].sort(function(a,b){
        return a.position -b.position
      }).map(function(slider, index) {
        return (
          <div className="item" key={slider.id || index}>
            <img
              src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${slider.attachment}`}
              alt={slider.title || `Slider ${index + 1}`}
              className="slider-image"
            />
          </div>
        )
      })}
    </Slider>
  );
};

export default Events;
